import React from 'react';
import './Services.css';

const services = [
	{
		accent: '#3aafa9',
		title: 'Azure DevOps Migration & Management',
		desc: 'End-to-end migrations, pipeline management, and board optimization. We own the complexity so your team stays focused on shipping.',
		tags: ['Azure DevOps', 'Pipelines', 'Boards'],
	},
	{
		accent: '#3a7fc1',
		title: 'CI/CD Modernization & Optimization',
		desc: 'Pipeline rebuilds for speed, reliability, and scale. GitOps workflows that reduce toil and get your team shipping with confidence.',
		tags: ['GitHub Actions', 'GitOps', 'YAML'],
	},
	{
		accent: '#7b5ea7',
		title: 'Infrastructure as Code',
		desc: 'Cloud infrastructure defined, versioned, and deployed as code. We work in your stack and build for long-term maintainability.',
		tags: ['Terraform', 'CDK', 'Bicep', 'CloudFormation'],
	},
	{
		accent: '#e05c2a',
		title: 'DevSecOps & Shift-Left Security',
		desc: 'Automated vulnerability scanning, SAST/DAST, and secrets management baked into every pipeline. Compliance-ready from day one.',
		tags: ['SAST/DAST', 'Scanning', 'Compliance'],
	},
];

export default function Services() {
	return (
		<section className='services' id='services'>
			<div className='services__inner'>
				<div className='section-eyebrow' style={{ color: '#3a7fc1' }}>
					WHAT WE DELIVER
				</div>
				<h2 className='section-heading'>
					Built for engineering teams ready to modernize
				</h2>
				<p className='section-lead'>
					We handle the infrastructure complexity so your team can focus on what
					matters — shipping great software.
				</p>
				<div className='services__grid'>
					{services.map((svc) => (
						<div className='svc-card' key={svc.title}>
							<div
								className='svc-card__accent'
								style={{ background: svc.accent }}
							/>
							<h3 className='svc-card__title'>{svc.title}</h3>
							<p className='svc-card__desc'>{svc.desc}</p>
							<div className='svc-card__tags'>
								{svc.tags.map((t) => (
									<span className='svc-tag' key={t}>
										{t}
									</span>
								))}
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
